<template>
    <b-modal
        :ref="modalRef"
        :id="modalRef"
        title-tag="h2"
        title="New Return"
        lazy
        @shown="focusClient"
    >
        <b-form-group label-for="date" label="Date:" label-cols="4">
            <date-picker
                id="date"
                name="date"
                :config="datePickerOptions"
                v-model="data.date"
                placeholder="Date (required)"
                v-validate="'required'"
                :class="{ 'border-danger': errors.has('date') }"
            />
        </b-form-group>

        <b-form-group label-for="client" label="Client:" label-cols="4">
            <vet-select
                id="client"
                ref="vetSelectClient"
                v-model="data.client"
                v-validate="'required'"
                :class="{
                    'border-danger': errors.has('client'),
                    rounded: true
                }"
                :show-menu="false"
                module="client"
                placeholder="Client Name (required)"
                name="client"
                :withMobile="false"
            />
        </b-form-group>

        <b-form-group label-for="note" label="Notes:" label-cols="4">
            <b-form-textarea
                placeholder="Notes (optional)"
                v-model="data.note"
                rows="3"
                name="note"
            />
        </b-form-group>

        <template v-slot:modal-footer>
            <modal-footer
                :is-loading="isLoading"
                ok-title="Save"
                @ok-action="save"
                @cancel-action="close"
            />
        </template>
    </b-modal>
</template>
<script type="text/javascript">
import BillingReturn from "@/services/billing/billing-return";

/**
 * @method NewReturnModal
 * @see /apps/application/views/staff/billing/sub/return/create_new.php
 */
export default {
    components: {
        modalFooter: () => import("@/components/elements/modal-footer"),
        vetSelect: () => import("@/module/commons/vet-select")
    },
    mixins: [],
    props: {
        modalRef: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isLoading: false,
            data: {
                date: null,
                client: null,
                note: null
            },
            datePickerOptions: {
                format: ""
            }
        };
    },
    methods: {
        open() {
            this.data.date = this._now().toFormat(this._dateFormat);
            this.datePickerOptions.format = this.getDateFormat();
            this.$refs[this.modalRef].show();
        },
        focusClient() {
            this.$refs["vetSelectClient"].focus();
        },
        async save() {
            this.isLoading = true;
            let valid = await this.$validator.validateAll();

            if (!valid) {
                this.isLoading = false;
                return;
            }

            let params = {
                client_id: this.data.client.id,
                return_date: this._fromDateStrToDateTime(this.data.date, true),
                note: this.data.note
            };

            BillingReturn.newReturn(params)
                .then(response => {
                    if (response.code == 200) {
                        // TODO: will use the view routes once the return page migration has been done
                        window.location.href = response.resources.ci_url;
                    } else {
                        throw response.message;
                    }
                    this.close();
                })
                .catch(error => {
                    this._message(
                        "Error : Unable to create new return",
                        "danger"
                    );
                    console.error(error);
                    this.close();
                });
        },
        close() {
            this.isLoading = false;
            this.$refs[this.modalRef].hide();
        }
    }
};
</script>
